export default "__VITE_ASSET__8bda926f__"